import React from "react";
import { withTheme } from "styled-components";
import { FormattedMessage } from "@irati/utils/lang";
import Flex from "@irati/ui/src/Flex";
import { H5, Label } from "@irati/ui/src/Typography";
var BoostedSaving = function (_a) {
    var value = _a.value, theme = _a.theme;
    return (React.createElement(Flex, { direction: "column" },
        React.createElement(Label, { small: true, color: "" + theme.colors.primary2, textAlign: "right" },
            React.createElement(FormattedMessage, { id: "perks.deals.boostedSaving.boostedAmount.text" })),
        React.createElement(H5, { color: "" + theme.colors.primary2, textAlign: "right" }, value + "%")));
};
export default withTheme(BoostedSaving);
